import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: {
            version: '1.1',
            id: 'Capa_1',
            x: '0px',
            y: '0px',
            viewBox: '0 0 477.867 477.867',
        },
        child: [
            {
                tag: 'g',
                attr: {},
                child: [
                    {
                        tag: 'g',
                        attr: {},
                        child: [
                            {
                                tag: 'path',
                                attr: {
                                    d: 'M238.933,0C106.974,0,0,106.974,0,238.933s106.974,238.933,238.933,238.933s238.933-106.974,238.933-238.933\r\n\t\t\tC477.726,107.033,370.834,0.141,238.933,0z M370.466,165.666L199.799,336.333c-6.665,6.663-17.468,6.663-24.132,0l-68.267-68.267\r\n\t\t\tc-6.78-6.548-6.968-17.352-0.42-24.132c6.548-6.78,17.352-6.968,24.132-0.42c0.142,0.138,0.282,0.277,0.42,0.42l56.201,56.201\r\n\t\t\tl158.601-158.601c6.78-6.548,17.584-6.36,24.132,0.419C376.854,148.567,376.854,159.052,370.466,165.666z',
                                },
                            },
                        ],
                    },
                ],
            },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
            { tag: 'g', attr: {}, child: [] },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const TickFilled = React.forwardRef(IconComponent);
TickFilled.displayName = 'TickFilled';

export { TickFilled };
